export const getHashParams = (clearParams = false) => {
    // replace # with &, as URLSearchParams expected in that format
    const params = new URLSearchParams(decodeURIComponent(window.location.hash).slice(1).replaceAll("#", "&"));

    if (clearParams) {
        history.replaceState(null, "", " ");
    }

    return params;
};
